let registry = {}

export function register(key, value) {
    if (registry[key] !== undefined)
        throw new Error("Allerede registrert: " + key.toString())
    registry[key] = value
}

export function resolve(key) {
    if (registry[key] === undefined) 
        throw new Error("Ikke registrert: " + key.toString())
    return registry[key]
}

export function deregister(key) {
    if (registry[key] === undefined)
        throw new Error("Kan ikke slette. Ikke registrert: " + key.toString())
    delete registry[key]
}

export function reset() {
    registry = {}
}


// WEBPACK FOOTER //
// ./src/dependencies.js